import React from "react";

export default function StatusBadge({ status }) {
  const value = String(status || "-").toUpperCase();
  const tone =
    value === "BATE"
      ? "ok"
      : value.includes("NÃO")
        ? "danger"
        : value === "OFICIAL"
          ? "info"
          : "muted";

  return <span className={`swb-badge swb-badge--${tone}`}>{status || "-"}</span>;
}
